import type { User } from 'firebase/auth'
import type { BaseSliceState } from '../types'

export interface AuthState extends BaseSliceState {
  user: User | null
  isAuthenticated: boolean
  initialized: boolean
}

export enum AuthActionTypes {
  AUTH_INIT = 'auth/init',
  AUTH_SUCCESS = 'auth/success',
  AUTH_LOGOUT = 'auth/logout',
  AUTH_ERROR = 'auth/error',
  AUTH_LOADING = 'auth/loading'
}

export type AuthAction =
  | { type: AuthActionTypes.AUTH_INIT }
  | { type: AuthActionTypes.AUTH_SUCCESS; payload: User }
  | { type: AuthActionTypes.AUTH_LOGOUT }
  | { type: AuthActionTypes.AUTH_ERROR; payload: string }
  | { type: AuthActionTypes.AUTH_LOADING; payload: boolean }
